import React from 'react';
import { BlogPost } from './BlogPost';
// import styles from './Blog.module.css';

export const Blog = ({ className = '' }) => {
  return <BlogPost />;
};
